import { useSelector } from 'react-redux';
import { selectAllStrings } from '../language/languageSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import '../../stylesheets/ThankYouPage.css';
import { useLocation } from "react-router-dom";
import { useEffect, useState } from 'react';

const ThankYouPage = () => {
    const strings = useSelector(selectAllStrings);
    const location = useLocation();
    
    


    return <div className="thank-you-page page">
        <h1>{strings.thanks_for_purchase}</h1>
        <div className="icon">
            <FontAwesomeIcon icon={faCheckCircle}/>
        </div>
        <h2>{strings.thank_you}</h2>
        <p>{strings.purchased_access}</p>
        <div className="credentials">
            <p>{strings.username}: <b>{window.localStorage.getItem('username')}</b></p>
            <p>{strings.password}: <b>{window.localStorage.getItem('password')}</b></p>
        </div>
        <p>{strings.save_information}</p>
        <div className="bottom">
            <NavLink to="/home" className="btn" id="home_page_button">{strings.home_page}</NavLink>
            <div className="support">{strings.for_any} <a href="tel:0685305377">0685305377</a> </div>
        </div>
    </div>;
};

export default ThankYouPage;